"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRedBullTVLivestreamProperty = exports.redBullTVLivestreamPropertyDefinition = void 0;
exports.redBullTVLivestreamPropertyDefinition = {
    view: { label: 'RBTV livestream' },
    constraints: [
        {
            name: 'providers',
            argument: ['RBMN Live', 'RBTV Video'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'service',
    multiple: false,
    name: 'redbulltv-livestream',
};
const isRedBullTVLivestreamProperty = (prop) => {
    return prop.name === exports.redBullTVLivestreamPropertyDefinition.name;
};
exports.isRedBullTVLivestreamProperty = isRedBullTVLivestreamProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVkYnVsbHR2LWxpdmVzdHJlYW0ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZWRidWxsdHYtbGl2ZXN0cmVhbS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHFDQUFxQyxHQUFHO0lBQ25ELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxpQkFBaUIsRUFBRTtJQUNsQyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxDQUFDLFdBQVcsRUFBRSxZQUFZLENBQUM7U0FDdEM7UUFDRDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtJQUNELElBQUksRUFBRSxTQUFTO0lBQ2YsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsc0JBQXNCO0NBQ0csQ0FBQTtBQUkxQixNQUFNLDZCQUE2QixHQUFHLENBQUMsSUFBa0IsRUFBdUMsRUFBRTtJQUN2RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ2pFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9